export default __webpack_public_path__ + "static/hero-video-8c94d9621f460cfad698dc8a70c3691d.mp4";